import React from "react";
import "./alert_type_badge.scss";

export const ALERT_TYPES = {
    info: "info",
    success: "success",
    warning: "warning",
    danger: "danger"
};

export const ALERT_TYPE_META = {
    [ALERT_TYPES.info]:    { icon: "fa-info-circle" },
    [ALERT_TYPES.success]: { icon: "fa-check-circle" },
    [ALERT_TYPES.warning]: { icon: "fa-exclamation-triangle" },
    [ALERT_TYPES.danger]:  { icon: "fa-times-circle" }
};

const normalizeType = type => {
    if (!type) {
        return ALERT_TYPES.success;
    }
    return String(type).toLowerCase();
};

const AlertTypeBadge = ({ type, label: labelProp, size, variant, ...rest }) => {
    const normalizedType = normalizeType(type);
    const { icon } = ALERT_TYPE_META[normalizedType] || ALERT_TYPE_META[ALERT_TYPES.success];
    const label = labelProp !== undefined
        ? labelProp
        : normalizedType.charAt(0).toUpperCase() + normalizedType.slice(1);

    return (
        <span
            {...rest}
            className={[
                "alert-type-badge",
                `alert-type-badge--${normalizedType}`,
                size    && `alert-type-badge--${size}`,
                variant && `alert-type-badge--${variant}`
            ].filter(Boolean).join(" ")}
        >
            <i className={`fas ${icon}`} aria-hidden="true" />
            {label}
        </span>
    );
};

export default AlertTypeBadge;

export const alertTypeOptions = Object.values(ALERT_TYPES).map(type => ({
    value: type,
    label: type.charAt(0).toUpperCase() + type.slice(1)
}));

export const formatAlertTypeOption = ({ value }) => <AlertTypeBadge type={value} />;